import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { setFilteredBlogs } from "../../store/siteWebSlice";
import { IBlog } from "./interface";




const SearchBar = () => {


  const dispatch = useDispatch();
  const { blogs } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const theme = useTheme();
  const lgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState("");


  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setFilteredBlogs([...blogs]));
    } else {
      const result: any = blogs.filter(
        (item: IBlog, index: number) => {
          const value: any = `${item.titre} ${item.titre}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredBlogs(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: lgDown ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
